import { ELiteratureType, EAssessmentDecision, EExclusionReason, EReviewingStage } from './types';

export const LITERATURE_LIST_QUERY_KEY = 'literatures';

// URL search-param keys the literature module reads and writes. Keep call sites honest about what
// they're pulling out of the URL and avoid drift when the key changes.
export const PRODUCT_IDS_SEARCH_PARAM = 'productIds';

export const EXCLUSION_REASON_ENABLED = false;

export const TYPE_OPTIONS: { value: ELiteratureType; label: string }[] = [
  { value: ELiteratureType.CLINICAL_TRIAL, label: 'Clinical trial' },
  { value: ELiteratureType.META_ANALYSIS, label: 'Meta-analysis' },
  { value: ELiteratureType.RCT, label: 'Randomized controlled trial' },
  { value: ELiteratureType.REVIEW, label: 'Review' },
  { value: ELiteratureType.SYSTEMATIC_REVIEW, label: 'Systematic review' },
  { value: ELiteratureType.BOOK_OR_DOCUMENT, label: 'Book or document' },
  { value: ELiteratureType.OTHER, label: 'Other' },
];

export const DECISION_OPTIONS: { value: EAssessmentDecision; label: string }[] = [
  { value: EAssessmentDecision.INCLUDED, label: 'Included' },
  { value: EAssessmentDecision.EXCLUDED, label: 'Excluded' },
  { value: EAssessmentDecision.PENDING, label: 'Pending' },
];

export const REVIEWING_STAGE_OPTIONS: { value: EReviewingStage; label: string }[] = [
  { value: EReviewingStage.NOT_REVIEWED, label: 'Not reviewed' },
  { value: EReviewingStage.ABSTRACT_APPROVED, label: 'Abstract approved' },
  { value: EReviewingStage.FULL_TEXT_APPROVED, label: 'Full text approved' },
];

export const EXCLUSION_REASON_OPTIONS: { value: EExclusionReason; label: string }[] = [
  { value: EExclusionReason.WRONG_DEVICE, label: 'Wrong device' },
  { value: EExclusionReason.WRONG_INDICATION, label: 'Wrong indication / intended use' },
  { value: EExclusionReason.WRONG_POPULATION, label: 'Wrong population' },
  { value: EExclusionReason.WRONG_OUTCOME, label: 'Wrong outcome' },
  { value: EExclusionReason.WRONG_STUDY_DESIGN, label: 'Wrong study design' },
  { value: EExclusionReason.WRONG_PUBLICATION_TYPE, label: 'Wrong publication type' },
  { value: EExclusionReason.PRECLINICAL, label: 'Preclinical / animal / in-vitro' },
  { value: EExclusionReason.DUPLICATE, label: 'Duplicate / superseded' },
  { value: EExclusionReason.OTHER, label: 'Other' },
];

export const FIELD_LABELS: Record<string, string> = {
  type: 'Article type',
  title: 'Title',
  authors: 'Authors',
  publicationYear: 'Publication year',
  volume: 'Volume',
  issue: 'Issue',
  pages: 'Pages',
  containerTitle: 'Journal / Container title',
  publisher: 'Publisher',
  doi: 'DOI',
  url: 'URL',
  accessDate: 'Access date',
  pmid: 'PMID',
};

export const LITERATURES_UI_MARGIN_TOP = 415;

export const LITERATURES_TABLE_ID = 'literatures-table';
